import { style, keyframes } from '@vanilla-extract/css';
import { vars, reducedMotion, mobile } from '@/shared/ui/theme';

export const container = style({
  width: '480px',
  height: '90px',
  marginTop: '-5px',
  flexShrink: 0,
  background: `${vars.bright.signature.cyanMist}`,
  border: `1px solid ${vars.bright.signature.cyanWash}`,
  borderRadius: '4px',
  padding: '4px 0',
  // 폭 480px 고정이라 조상 authScene(width:100% + overflow:hidden) 안에서
  // 480px 미만 화면(모든 iPhone)은 좌우가 잘렸다. SVG 는 viewBox 만 있고
  // width/height 가 없어 컨테이너를 줄이면 내용이 비례 축소된다. (authPanel 과 동일 패턴)
  '@media': {
    [mobile]: {
      width: '100%',
      maxWidth: '480px',
    },
  },
});

const pulseRing = keyframes({
  '0%, 100%': { opacity: '0.3', transform: 'scale(1)' },
  '50%': { opacity: '0.8', transform: 'scale(1.6)' },
});

export const nodeGlowPulse = style({
  transformOrigin: 'center',
  transformBox: 'fill-box',
  animation: `${pulseRing} 2.5s ease-in-out infinite`,
  '@media': { [reducedMotion]: { animation: 'none', opacity: '0.5' } },
});

const flowDash = keyframes({
  '0%': { strokeDashoffset: '20' },
  '100%': { strokeDashoffset: '0' },
});

export const energyFlow = style({
  animation: `${flowDash} 1.2s linear infinite`,
  '@media': { [reducedMotion]: { animation: 'none' } },
});

const fadeUp = keyframes({
  '0%': { opacity: '1', transform: 'translateY(0)' },
  '100%': { opacity: '0', transform: 'translateY(-12px)' },
});

export const containerExiting = style({
  animation: `${fadeUp} ${vars.animation.duration.slow} ${vars.animation.easing.easeIn} forwards`,
  '@media': { [reducedMotion]: { animation: 'none', opacity: '0' } },
});
